import { TerritoryMapStoreModels } from './territoryMapData.state';
export const TERRITORY_MAP_REQUEST = '[Reports] territory-map-request'; 
export const TERRITORY_MAP_SUCSSES = '[Reports] territory-map-success';
export const TERRITORY_MAP_FAILD = '[Reports] territory-map-faild';

// Actions for Visit Reports
export class TerritoryMapRequestAction {
    readonly type = TERRITORY_MAP_REQUEST ;
}

  export class TerritoryMapSuccessAction {
    readonly type = TERRITORY_MAP_SUCSSES;

    constructor(public payload?: TerritoryMapStoreModels){}
  }

  export class TerritoryMapFaildAction {
    readonly type = TERRITORY_MAP_FAILD;

    constructor(public payload?: any){}
  }
